import styled from 'styled-components'

import colors from '../../../lib/Colors'
import ShimmerBlock from '../../shared/ShimmerBlock'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
  ${(props) =>
    props.dropLegacyStyles
      ? ''
      : `@media (min-width: ${props.theme.breakpoints.tablet}) {
    width: calc(50% - 24px);
    &:nth-of-type(odd) {
      /*Leftmost column*/
      margin-right: 48px;
    }
  }
  @media (min-width: ${props.theme.breakpoints.desktop}) {
    width: calc(33% - 20px);
    margin-right: 0px;
    &:nth-of-type(odd) {
      margin-right: 0px;
    }
    &:nth-of-type(3n + 1) {
      /*Leftmost column*/
      margin-right: 35px;
    }
    &:nth-of-type(3n + 3) {
      /*Rightmost column*/
      margin-left: 35px;
    }
  }`}
`

const HeaderBlock = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: spaceBetween;
  padding: 4px 8px 4px 4px;
`
const BodyBlock = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 24px 16px 16px;
`

const CampaignInfo = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${colors.gray_400};
  border-bottom: 1px solid ${colors.gray_400};
`

const FooterBlock = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const CampaignCardShimmer = (props) => (
  <Wrapper dropLegacyStyles={props.dropLegacyStyles}>
    <HeaderBlock>
      <ShimmerBlock height="40px" width="40px" />
      <ShimmerBlock height="20px" margin="10px" width="200px" />
    </HeaderBlock>
    <ShimmerBlock height="104px" width="100%" />
    <BodyBlock>
      <ShimmerBlock height="30px" width="100%" />
      <ShimmerBlock height="20px" width="100px" />
      <ShimmerBlock height="100px" width="100%" />
    </BodyBlock>
    <CampaignInfo>
      <ShimmerBlock height="24px" radius="24px" width="24px" />
      <ShimmerBlock height="24px" width="100px" />
    </CampaignInfo>
    <FooterBlock>
      <ShimmerBlock height="16px" radius="16px" width="16px" />
      <ShimmerBlock height="18px" margin="8px" width="160px" />
    </FooterBlock>
  </Wrapper>
)

export default CampaignCardShimmer
